module.exports = __webpack_public_path__ + "static/media/Upload.266ee136.svg";